import { b3Viem } from "../../shared/constants/chains/b3Viem.js";
import { supportedChains } from "../../shared/constants/chains/supported.js";
const baseChainBaseUrl = "https://basescan.org";
export function getChainById(id) {
    return Object.values(supportedChains).find(chain => chain.id === id);
}
export function chainIdToName(id) {
    const name = getChainById(id)?.name;
    return name === "Base Mainnet" ? "Base" : name === "The Open Network" ? "Open Network" : name;
}
export function getExplorerUrl(chain, txHash) {
    if (chain.id === b3Viem.id) {
        return "https://explorer.b3.fun/b3/tx/" + txHash;
    }
    let baseUrl = chain.blockExplorers?.default.url;
    if (chain.id === 8453) {
        baseUrl = baseChainBaseUrl;
    }
    return baseUrl ? `${baseUrl}/tx/${txHash}` : "";
}
export function getAddressExplorerUrl(chain, address) {
    let baseUrl = chain.blockExplorers?.default.url;
    if (chain.id === 8453) {
        baseUrl = baseChainBaseUrl;
    }
    return baseUrl ? `${baseUrl}/address/${address}` : "";
}
export function getTokenExplorerUrl(chain, tokenAddress, tokenId) {
    let baseUrl = chain?.blockExplorers?.default?.url ?? "https://explorer.b3.fun";
    if (chain.id === 8453) {
        baseUrl = baseChainBaseUrl;
    }
    const tokenUrl = `${baseUrl}/token/${tokenAddress}`;
    return tokenId ? `${tokenUrl}/instance/${tokenId}` : tokenUrl;
}
